export const EXAM_TYPES = Object.freeze({
    GRE: 'GRE',
    GMAT: 'GMAT',
    IELTS: 'IELTS',
    TOEFL: 'TOEFL'
});
export const NOT_PLANNING_TO_TAKE_APTITUDE_TEST = 'Not Planning to Take';
export const APTITUDE_EXAM_TYPE_OPTIONS = [
    {
        id: 1,
        label: EXAM_TYPES.GRE,
        value: EXAM_TYPES.GRE
    },
    {
        id: 2,
        label: EXAM_TYPES.GMAT,
        value: EXAM_TYPES.GMAT
    },
    {
        id: 3,
        label: NOT_PLANNING_TO_TAKE_APTITUDE_TEST,
        value: NOT_PLANNING_TO_TAKE_APTITUDE_TEST
    }
];
export const ENGLISH_EXAM_TYPE_OPTIONS = [
    {
        id: 1,
        label: EXAM_TYPES.IELTS,
        value: EXAM_TYPES.IELTS
    },
    {
        id: 2,
        label: EXAM_TYPES.TOEFL,
        value: EXAM_TYPES.TOEFL
    }
];

export const WORK_STATUS = [
    {
        id: 1,
        label: 'Student',
        isWorking: false
    },
    {
        id: 2,
        label: 'Working Professional',
        isWorking: true
    }
];
export const INTAKE_YEARS = [
    {
        id: 1,
        label: 2026,
        value: 2026,
        isRecommended: true
    },
    {
        id: 2,
        label: 2027,
        value: 2027
    },
    {
        id: 3,
        label: 2028,
        value: 2028
    }
];

export const ONBOARDING_DETAILS = Object.freeze({
    [EXAM_TYPES.GRE]: {
        WORK_STATUS
    },
    [EXAM_TYPES.GMAT]: {
        WORK_STATUS
    }
});
